<template>
  <div class="alert alert-danger">
    <div class="container">
      <div class="alert-icon">
        <md-icon>info_outline</md-icon>
      </div>
      Mütləq sahə!
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
</style>